module.exports = __webpack_public_path__ + "img/f347195.jpg";